import { defineElement, html, TemplateElement } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import templateInput from './input.template';

export default class AsyncFormElement extends TemplateElement {
    properties() {
        return {
            action: '',
            method: 'POST',
            name: '',
            ctaLabel: '',
            ctaClass: 'btn btn-brand',
            negativeCtaLabel: '',
            negativeCtaClass: 'btn btn-outline-dark',
            agbText: false,
            gridGap: 'gap-4',
            errors: {},
            showGlobalErrorMessage: false,
            globalErrorMessage: 'Es ist ein Fehler aufgetreten!',
            showSuccessMessage: false,
            successMessage: 'Das hat geklappt!',
            inputs: [],
            redirectTarget: false,
        };
    }

    events() {
        return {
            form: {
                submit: async ev => {
                    ev.preventDefault();
                    ev.stopPropagation();

                    // reset flags
                    this.showGlobalErrorMessage = false;
                    this.showSuccessMessage = false;
                    this.errors = {};

                    await this.$refs.captcha?.setToken();

                    const data = {};
                    new FormData(ev.target).forEach((value, key) => {
                        data[key] = value;
                    });

                    try {
                        const response = await fetch(this.action, {
                            method: this.method,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(data),
                        });

                        if (!response.ok) {
                            this.errors = (await response.json()) || {};
                            if (Object.keys(this.errors).length === 0) {
                                this.showGlobalErrorMessage = true;
                            }
                            return;
                        }

                        this.dispatch('ASYNC_FORM_SUBMITTED');
                        if (this.redirectTarget) {
                            this.errors = {};
                            this.redirectToTarget();
                        } else if (this.successMessage) {
                            this.showSuccessMessage = true;
                        }
                    } catch (e) {
                        this.showGlobalErrorMessage = true;
                    }
                },
            },
        };
    }

    getError(name) {
        return this.errors[name] || '';
    }

    redirectToTarget() {
        window.location.href = this.redirectTarget;
    }

    template() {
        return html`
            <form class="block space-y-5" action="${this.action}" method="${this.method}" id="${this.name}">
                <div class="grid grid-cols-12 ${this.gridGap}">
                    ${this.inputs.map(input => {
                        const errorMessage = this.getError(input.name);
                        return html` ${templateInput(input, errorMessage)} `;
                    })}
                </div>

                ${this.agbText
                    ? html` <div class="rich-text-style text-center">${unsafeHTML(this.agbText)}</div>`
                    : html``}
                ${this.showGlobalErrorMessage
                    ? html` <div class="text-sm text-center text-danger-500">${this.globalErrorMessage}</div> `
                    : html``}

                <div
                    class="flex flex-col gap-4 ${this.negativeCtaLabel
                        ? 'justify-between'
                        : 'justify-center'} md:flex-row md:gap-0"
                >
                    ${this.negativeCtaLabel
                        ? html` <div class="text-center">
                              <button onclick="history.back()" class="btn ${this.negativeCtaClass}">
                                  ${this.negativeCtaLabel}
                              </button>
                          </div>`
                        : ''}
                    ${this.showSuccessMessage
                        ? html`<div class="text-center text-info-500">${unsafeHTML(this.successMessage)}</div> `
                        : html`
                              <div class="text-center">
                                  <button ref="submitButton" class="btn ${this.ctaClass}">${this.ctaLabel}</button>
                              </div>
                          `}
                </div>
            </form>
        `;
    }
}

defineElement('async-form-element', AsyncFormElement);
